import React, { useEffect } from 'react';
import { Container, Header } from 'semantic-ui-react';
import { PageHeader, Wrappers } from '../components';
import './SuretrackReferral.css';
import './AugerCalculator.css';

const SuretrackReferral = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Wrappers.Layout menu>
      <Container as="main">
        <PageHeader overlap>
          <Header as="h1" data-qa="warranty-claims-header">
            <small>Auger</small>
            Length Calculator
          </Header>
        </PageHeader>
        <div
          class="elfsight-app-17d48558-628c-47b7-8789-e85eb916b94e"
          data-elfsight-app-lazy
        ></div>
      </Container>
    </Wrappers.Layout>
  );
};

export default SuretrackReferral;
